window.addEventListener('load', function() {

        var actualDaysDiv = document.getElementsByClassName('actualDays');
        if (actualDaysDiv.length > 0) {
            
             

    		//Estimated date function on product page
            var date = new Date();
            var newdate = new Date(date);
      		var target,dateNumber,dd,mm,y,someFormattedDate,stringDate;
      
            let dayNumber = document.querySelector('#dataPara');
            if (dayNumber) {
                target = dayNumber.getAttribute('data-estimated-time');            
            };  
      
            newdate.setDate(newdate.getDate() + parseInt(target));
    
            var dateNumber = newdate.getDate();
            var dd = getDayOfWeek(newdate);
            var mm = monthNames[newdate.getMonth()];
            var y = newdate.getFullYear();
    
      
            if(dd == 'Samstag'){
              newdate.setDate(newdate.getDate() + parseInt(2));          
              var dateNumber2 = newdate.getDate();
              var dd2 = getDayOfWeek(newdate);
              var mm2 = monthNames[newdate.getMonth()];
              var y2 = newdate.getFullYear();          
              
              var someFormattedDate2 =  dd2 + ', ' + mm2 + ' ' + dateNumber2 + ', ' + y2;
              var stringDate2 = someFormattedDate2.toString();
    
              let assignDate2 = document.querySelector('.actualDays');
              assignDate2.innerHTML = stringDate2;
              document.getElementById('follow_Date').value = stringDate2;          
                                  
            }else if(dd == 'Sonntag'){
              newdate.setDate(newdate.getDate() + parseInt(1));          
              var dateNumber1 = newdate.getDate();
              var dd1 = getDayOfWeek(newdate);
              var mm1 = monthNames[newdate.getMonth()];
              var y1 = newdate.getFullYear();          
              
              var someFormattedDate1 =  dd1 + ', ' + mm1 + ' ' + dateNumber1 + ', ' + y1;
              var stringDate1 = someFormattedDate1.toString();
    
              let assignDate1 = document.querySelector('.actualDays');
              assignDate1.innerHTML = stringDate1;
              document.getElementById('follow_Date').value = stringDate1;          
                                  
            }else{
              
              var someFormattedDate =  dd + ', ' + mm + ' ' + dateNumber + ', ' + y;
              var stringDate = someFormattedDate.toString();
              //console.log(stringDate);
    
              let assignDate = document.querySelector('.actualDays');
              assignDate.innerHTML = stringDate;
              //document.getElementById('follow_Date').value = stringDate;                   
            }  

        }
  
  
});

    function getDayOfWeek(date) {
      var dayOfWeek = new Date(date).getDay();    
      return isNaN(dayOfWeek) ? null : 
        ['Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag'][dayOfWeek];
    }
    var monthNames = ["Januar", "Februar", "März", "April", "Mai", "Juni",
      "Juli", "August", "September", "Oktober", "November", "Dezember"
    ];

$(document).ready(function() {


        $('.listedBundleContent').slick({          
          centerPadding: '30px',
          slidesToShow: 3,
          slidesToScroll: 1,
          arrows: true,
          responsive: [
            {
              breakpoint: 1366,
              settings: {
                centerPadding: '20px',
                slidesToShow: 2
              }
            },      
            {
              breakpoint: 640,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,                
                centerMode: false,
                draggable: false,
                centerPadding: '0px',
                variableWidth: false
              }
            }
          ]
        }); 

    

    function AddReadMore() {
        //This limit you can set after how much characters you want to show Read More.
        var carLmt = 100;
        // Text to show when text is collapsed
        var readMoreTxt = " ... Mehr lesen";
        // Text to show when text is expanded
        var readLessTxt = " Lese weniger";
    
    
        //Traverse all selectors with this class and manupulate HTML part to show Read More
        $(".addReadMore").each(function() {
            if ($(this).find(".firstSec").length)
                return;
    
            var allstr = $(this).text();
            if (allstr.length > carLmt) {
                var firstSet = allstr.substring(0, carLmt);
                var secdHalf = allstr.substring(carLmt, allstr.length);
                var strtoadd = firstSet + "<span class='SecSec'>" + secdHalf + "</span><span class='readMore'  title='Click to Show More'>" + readMoreTxt + "</span><span class='readLess' title='Click to Show Less'>" + readLessTxt + "</span>";
                $(this).html(strtoadd);
            }
    
        });
        //Read More and Read Less Click Event binding
        $(document).on("click", ".readMore,.readLess", function() {
            $(this).closest(".addReadMore").toggleClass("showlesscontent showmorecontent");
        });
    }

    AddReadMore();

  

document.addEventListener('variant:changed', function(event) {
   var variant = event.detail.variant; // Gives you access to the whole variant details
  console.log(variant);
});  

    var timeDiv = document.getElementById('time');
    if (timeDiv) {  
        
        // CountDown Timer Starts
        var getValue = $("strong#time").text();
        
        var start = new Date;
        start.setHours(getValue, 0, 0); // 11pm
      
        tick();
        
        function pad(num) {
          return ("0" + parseInt(num)).substr(-2);
        }
      
        function tick() {
          var now = new Date;
          if (now > start) { // too late, go to tomorrow
            start.setDate(start.getDate() + 1);
          }
          var remain = ((start - now) / 1000);
          var hh = pad((remain / 60 / 60) % 60);
          var mm = pad((remain / 60) % 60);
          // var ss = pad(remain % 60);
          document.getElementById('time').innerHTML = hh + ":" + mm;
          setTimeout(tick, 1000);
        }
      
      // CountDown Timer Ends

    }

  

});